import card from './card'
import contextMenu from './context-menu'
import currentState from './current-state'
import content from './content'
import deprecatedTrends from './deprecated-trends'
import filter from './filter'
import form from './form'
import header from './header'
import list from './list'
import innovationFields from './innovationFields'
import participants from './particpants'
import publicLink from './public-link'
import stateSwitch from './state-switch'
import states from './states'
import propose from './propose'
import proposalForm from './proposal-form'
import selection from './selection'
import threads from './threads'
import trends from './trends'
import trendradars from './trendradars'

export default {
    card,
    contextMenu,
    currentState,
    content,
    deprecatedTrends,
    filter,
    form,
    header,
    list,
    innovationFields,
    participants,
    stateSwitch,
    states,
    publicLink,
    propose,
    proposalForm,
    selection,
    threads,
    trends,
    trendradars
}
